import React from 'react';
import { GiLotus, GiMeditation, GiPrayerBeads, GiStonePath, GiPeaceDove } from 'react-icons/gi';
import { FaUsers, FaHandsHelping, FaBook, FaHeart } from 'react-icons/fa';
import './aboutus.css';

function AboutUs() {
  return (
    <div className="dharma-container">
      {/* Sacred Lotus Header */}
      <div className="sacred-header">
        <GiLotus className="lotus-icon" />
        <h1 className="enlightened-title">About Enlightened Path Fellowship</h1>
        <GiLotus className="lotus-icon" />
      </div>

      {/* Introduction Section */}
      <section className="golden-section">
        <div className="section-content">
          <GiStonePath className="section-icon" />
          <p className="dharma-text">
            Founded in 2024, Enlightened Path Fellowship Inc. is committed to fostering Buddhist teachings, 
            meditation, and cultural values within the Sri Lankan and wider Australian community. Our temple, 
            Ehipassiko Buddhist Center Bundoora, serves as a sanctuary for spiritual growth, cultural enrichment, social welfare and non-profit organization guided by the compassionate wisdom of Lord Buddha.
          </p>
        </div>
      </section>

      {/* Leadership Section */}
      <section className="saffron-section">
        <h2 className="section-title">
          <FaUsers className="title-icon" /> Our Spiritual Leadership
        </h2>
        <div className="leadership-grid">
          <div className="leader-card">
            <div className="leader-icon"><GiPrayerBeads /></div>
            <h3>Chief Incumbent Monk</h3>
            <p>Venerable Korathota Dhammadassi Thero</p>
          </div>
          <div className="leader-card">
            <div className="leader-icon"><FaHeart /></div>
            <h3>Vice Chairman</h3>
            <p>Mr. Krishan Sanjeewa Perera</p>
          </div>
          <div className="leader-card">
            <div className="leader-icon"><FaBook /></div>
            <h3>Secretary</h3>
            <p>Mr.Dinush Maduranga Samarasiri</p>
          </div>
          <div className="leader-card">
            <div className="leader-icon"><FaHandsHelping /></div>
            <h3>Treasurer</h3>
            <p>Mr. Kokila Supun</p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="golden-section">
        <h2 className="section-title">
          <GiPeaceDove className="title-icon" /> Our Sacred Mission
        </h2>
        <div className="mission-grid">
          {[
            "Establishing a permanent Buddhist center in Melbourne's northern suburbs",
            "Providing opportunities to study and practice the Dhamma",
            "Promoting mindfulness and meditation for mental well-being",
            "Supporting Sinhala language learning in VCE curriculum",
            "Preserving Buddhist cultural and ethical values",
            "Organizing welfare initiatives for our community",
            "Guiding young Sri Lankans in Australian society"
          ].map((item, index) => (
            <div key={index} className="mission-item">
              <div className="mission-icon">✓</div>
              <p>{item}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Services Section */}
      <section className="saffron-section">
        <h2 className="section-title">
          <GiMeditation className="title-icon" /> Our Spiritual Services
        </h2>
        <div className="services-timeline">
          {[
            { icon: <GiPrayerBeads />, title: "Daily Pujas", desc: "Evening prayers and religious ceremonies" },
            { icon: <GiMeditation />, title: "Weekly Meditation", desc: "Open sessions for inner peace" },
            { icon: "☸", title: "Monthly Sill", desc: "Full-day mindfulness and Dhamma learning" },
            { icon: "🕯", title: "Annual Festivals", desc: "Vesak & Katina celebrations" },
            { icon: "🎎", title: "Cultural Events", desc: "Sinhala & Hindu New Year festivals" },
            { icon: "💝", title: "Counseling", desc: "Support for those in need" },
            { icon: "👵", title: "Senior Programs", desc: "Community engagement activities" }
          ].map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Future Initiatives */}
      <section className="golden-section future-section">
        <h2 className="section-title">
          <GiStonePath className="title-icon" /> Future Initiatives
        </h2>
        <div className="initiatives-container">
          {[
            "Expanding meditation teachings to diverse audiences",
            "Supporting recovery from substance abuse",
            "Youth programs for ethical development",
            "Promoting interfaith harmony",
            "Establishing a Buddhist library"
          ].map((item, index) => (
            <div key={index} className="initiative-item">
              <span className="lotus-bullet">✿</span>
              <p>{item}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Blessing Footer */}
      <footer className="blessing-footer">
        <GiLotus className="footer-lotus" />
        <p className="blessing-text">
          Our center warmly welcomes all seekers of spiritual enlightenment, cultural connection, 
          and community support. May we walk together on this path toward wisdom, compassion, 
          and lasting peace.
        </p>
        <GiLotus className="footer-lotus" />
      </footer>
    </div>
  );
}

export default AboutUs;